exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coin-animation{position:absolute;width:120px;height:120px;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%)}.coin-animation .coin{height:100%;background-image:url(\"https://d2rzfffph148bz.cloudfront.net/web_store/images/coins_animation.png\");animation:coin_animation step-end .3s infinite}@-webkit-keyframes coin_animation{0%{background-position:0 0}14%{background-position:-120px 0}28%{background-position:-240px 0}43%{background-position:-360px 0}57%{background-position:-480px 0}72%{background-position:-600px 0}86%{background-position:-720px 0}}@keyframes coin_animation{0%{background-position:0 0}14%{background-position:-120px 0}28%{background-position:-240px 0}43%{background-position:-360px 0}57%{background-position:-480px 0}72%{background-position:-600px 0}86%{background-position:-720px 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27af7eb4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/animations/RotateCoin.vue
// module id = 378
// module chunks = 0